<span *ngIf="nestLevel > 0">
    <span>&#160; &#160;</span>
    <span *ngFor="let i of createDummyArray(nestLevel); let l = last; let f = first">
        <span *ngIf="!l">&#160;</span>
        <span *ngIf="l">&gt; </span>
    </span>
</span>
{{name}}